import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  "data-testid": "client-detail-managing-country-row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataWrapper, {
      class: "w-6/12",
      fontSize: 14
    }, {
      label: _withCtx(() => [
        _createVNode("span", {
          "data-testid": "client-detail-managing-country-label",
          class: _ctx.titleClass
        }, "Managing Country", 2)
      ]),
      default: _withCtx(() => [
        _createVNode("div", {
          "data-testid": "client-detail-managing-country-value",
          class: _ctx.valueClass
        }, _toDisplayString(_ctx.managingCountry || "-"), 3)
      ]),
      _: 1
    })
  ]))
}